import { css } from '@emotion/react';
import React from 'react';
import TextArea from "../../../TextArea";
import {
    columnModalLeft,
    columnModalRight,
    modalSubtitle,
    modalTextArea,
    modalTextDescription,
    rowModal
} from "../../styles";
import {IconBlue} from "../IconBlue";

export interface TextAreaEditProps {
    hideEdit?: boolean;
    name: string;
    value?: string;
    placeholder?: string;
    onChange?(name: string, value: string): void;
}

export interface TextAreaProps {
    label: React.ReactNode;
    value: React.ReactNode;
    editProps?: TextAreaEditProps;
}


export const TextAreaModal: React.FC<TextAreaProps> = ({
                                                        label,
                                                        value,
                                                        editProps,
                                                    }) => {
    return <div style={{width:'100%'}}>
                <div css={rowModal}>
                    <div css={columnModalLeft}>
                        <IconBlue/>
                        <p css={modalSubtitle}>{label}</p>
                    </div>
                </div>
                <div css={rowModal}>
                        <p css={modalTextArea} style={{width:'100%'}}>
                            {editProps && !editProps.hideEdit ?
                                <TextArea name={editProps.name} placeholder={editProps.placeholder} onChange={event => {
                                    const { name, value } = event.target;
                                    editProps?.onChange?.(name, value);
                                }} overrideCss={css` width: 100%; margin-top:10px; height:120px;`} value={editProps.value} />
                                : value}
                        </p>
                </div>
         </div>
};